import { Media } from "./media";

export interface Club {
    id: number;
    name: string;
    document_id: string;
    date_foundation: string;
    city: string;
    region: string;
    country: string;
    website: string;
    email: string;
    address: string;
    phone: string;
    registry_num: string;
    logo: Media[];
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyClub: Club = {
    id: 0,
    name: '',
    document_id: '',
    date_foundation: '0000-00-00',
    city: '',
    region: '',
    country: '',
    website: '',
    email: '',
    address: '',
    phone: '',
    registry_num: '',
    logo: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}